import { AziendaDiSessione } from "../../types";

/*
 L'azienda scelta da chi vede piu' aziende, tenuta dove appartiene: nella sessione.

 Fino al settembre 2026 la scelta non era un dato di sessione: `POST /auth/signin/{companyId}`
 la **scriveva** sulla riga dell'utente e ogni richiesta la rileggeva da li', una sola per
 utenza. Due schede non erano quindi indipendenti — chi sceglieva per ultimo sceglieva anche per
 l'altro, che restava sulla sua pagina mentre i dati che arrivavano erano di un'altra azienda.

 Ora la scelta e' ricordata qui, per scheda, in `sessionStorage`, come gia' fa lo stato Redux
 (`storageSession` in `src/app/store.ts`): un'altra scheda non la vede e la chiusura la porta
 via. **Ed e' la fonte di verita' dell'azienda di una richiesta**: ogni chiamata la dichiara
 nell'intestazione `X-Company-Id` (`src/provider/authProvider.tsx`) e il backend la onora dopo
 averla verificata contro il perimetro dell'utenza (ADR-0017 del backend). Il claim `companyId`
 del token e' rimasto solo come ripiego per chi l'intestazione non la manda. Due conseguenze:

  - una scheda e' indipendente dalle altre davvero, anche dopo una ricarica e anche
    condividendo lo stesso token: non c'e' piu' niente da riallineare quando la scheda torna
    visibile, ed e' per questo che la sorveglianza che se ne occupava non esiste piu';
  - se qui c'e' un'azienda che l'utenza non puo' piu' vedere, il backend rifiuta con 403 e non
    prosegue. La si dimentica e si torna alla scelta: `src/provider/authProvider.tsx`.
*/
const CHIAVE = "aziendaDiSessione";

export function ricordaAziendaDiSessione(azienda: AziendaDiSessione): void {
  sessionStorage.setItem(CHIAVE, JSON.stringify(azienda));
}

export function aziendaDiSessione(): AziendaDiSessione | null {
  const scritta = sessionStorage.getItem(CHIAVE);
  if (!scritta) {
    return null;
  }
  try {
    return JSON.parse(scritta) as AziendaDiSessione;
  } catch {
    // Una scrittura illeggibile vale come assente: peggio del non sapere c'e' solo il
    // credere di sapere.
    sessionStorage.removeItem(CHIAVE);
    return null;
  }
}

export function dimenticaAziendaDiSessione(): void {
  sessionStorage.removeItem(CHIAVE);
}
